// extracted by css-extract-rspack-plugin
export default {"link":"link-ziW8Re","compact":"compact-ov9_8N","menuItem":"menuItem-Zm_AHN"};